export default __webpack_public_path__ + "static/media/house.517eab4e.jpeg";